import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Footer from "components/Footer/Footer.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import dashGeneralPageStyle from "assets/jss/prehnit/views/dashGeneralPageStyle.jsx";

import { withNamespaces } from "react-i18next";

import CLCDashCompareTwo from "components/CLCDashboards/CLCDashCompareTwo.jsx";

import { checkTrans } from "helpers";

class DashMunicipalitiesPage extends React.Component {

  componentDidMount() {
    checkTrans('export');
  }


  render() {
    // console.log('DashMunicipalityPage: render');
    const { t, classes, match } = this.props;
    return (
      <div>
        <Header
          brand="CLCCro"
          links={<HeaderLinks dropdownHoverColor="primary" units/>}
          fixed
          color="white"
        />
        <Parallax image={require("assets/img/bkg/sidharth-bhatia-358983-unsplash-sm.jpg")} filter="dark" small>
          <div className={classes.container}>
            <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
                <h2 className={classes.title}>
                  {t("pagecontent:dash-municipality-title")}
                </h2>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <CLCDashCompareTwo
            history = {this.props.history}
            categoryCode = 'jls'
            mapTitle = {t("pagecontent:dash-municipality-title")}
            mapInitialZoom = {7}
            mapMinZoom = {7}
            mapMaxZoom = {10}
            mapAllowPan = {true}
            mapDataLayer = 'CLCCro:simple_opcine'
            regionOne = {match.params ? match.params.id1 : null }
            regionTwo = {match.params ? match.params.id2: null }
          />
        </div>
        <Footer
          content={
            <div></div>
          }
        />
      </div>
    );
  }
}

export default withNamespaces()(withStyles(dashGeneralPageStyle)(DashMunicipalitiesPage));